import { map, values } from 'lodash';
import { useSubmitCoachingAssessmentMutation } from '../../../graphQL';
import { useCoachingAssessmentContext } from '../contexts/coachingAssessmentContext';
import { CoachingAssessment } from './useCoachingAssessment';

type UseSaveCoachingAssessmentReturn = [
  saveAnswers: () => Promise<void>,
  info: {
    isSaving: boolean;
  },
];

export const useSaveCoachingAssessmentLazy = ({
  assessmentType,
  onCompleted,
  onError,
}: {
  assessmentType: CoachingAssessment;
  onCompleted?: () => void;
  onError?: () => void;
}): UseSaveCoachingAssessmentReturn => {
  const { answersByAssessment } = useCoachingAssessmentContext();

  const [submitAssessment, { loading }] = useSubmitCoachingAssessmentMutation({
    onCompleted,
    onError,
  });

  const saveAnswers = async (): Promise<void> => {
    const submissions = map(answersByAssessment, (answers, questionnaireKey) => {
      return {
        questionnaireKey,
        answers: values(answers),
      };
    });

    void submitAssessment({
      variables: {
        assessmentType,
        submissions,
      },
    });
  };

  return [saveAnswers, { isSaving: loading }];
};
